import { FC, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useOrderTemplatePermissions } from "./permissions";

/**
 * Guards the template management routes (create / edit). Non-admins are sent
 * back to the read-only templates list instead of being allowed to fill out a
 * form whose submit the backend will reject.
 */
export const TemplateAdminRoute: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const { canManage } = useOrderTemplatePermissions();

  if (!canManage) {
    return <Navigate to="/order-templates" replace />;
  }

  return children;
};

export default TemplateAdminRoute;
